export const ErrorPage: React.FC = () => {
  return (
    <div className="text-center">
      <h1 className="mt-8">you are on the error page</h1>
    </div>
  )
}
